import { useMemo } from 'react';
import { useParams } from 'react-router';
import { getUrl } from 'utils';
import { useSelector } from 'react-redux';
import {
  LocalizationLinkedList,
  PreviewApp,
  MinimumServingForm,
  Loader,
  ErrorComponent,
} from 'components';
import { publisherLocalizationPages } from 'constants';
import { routes } from 'config';
import { manageAppsAPI } from 'services/manageApps.service';
import { isAdvertiserRole } from 'store/selectors';
import * as S from './LocalMinimumServingPage.styled';

const LocalMinimumServingPage = () => {
  const { pba_id } = useParams();
  const isAdvertiser = useSelector(isAdvertiserRole);
  const pages = useMemo(
    () =>
      publisherLocalizationPages.map((page) => {
        return { ...page, link: getUrl(routes, page.url_id, pba_id) };
      }),
    [],
  );

  const { data, isError, isSuccess, isFetching } = manageAppsAPI.useFetchAppAdvancedDataQuery({
    pba_id,
    isAdvertiser,
  });
  const [saveMinimumServingAction, result] = manageAppsAPI.useSaveMinimumServingMutation();

  return (
    <>
      {isError && <ErrorComponent />}
      {!isSuccess && !isError && <Loader.Global delay={1} />}
      {data && (
        <S.Container>
          <h1>App Settings</h1>
          <S.Main>
            <S.Wrap>
              <S.ListPosition>
                <PreviewApp />
                <LocalizationLinkedList data={pages} show={true} />
              </S.ListPosition>
              <MinimumServingForm
                data={data}
                updateAction={saveMinimumServingAction}
                result={result}
                isFetching={isFetching}
              />
            </S.Wrap>
          </S.Main>
        </S.Container>
      )}
    </>
  );
};

export default LocalMinimumServingPage;
